module.exports = __webpack_public_path__ + "img/1_half.2401096d.png";